import { ReactSession } from "../../../../lib/secure_reactsession";

export async function generateTestingToolReport(payload) {
  const token = ReactSession.get("token");
  const response = await fetch(
    `${process.env.REACT_APP_IMG_URL}api/v2/researcher/mythology/testing-tool-generate-summary`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      body: payload,
    }
  );

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      (data && (data.error || data.message)) ||
      "Failed to generate testing tool report";
    throw new Error(message);
  }

  return data;
}

export async function exportTestingToolReport(testTestingToolId) {
  const token = ReactSession.get("token");
  const response = await fetch(
    `${process.env.REACT_APP_IMG_URL}api/v2/researcher/mythology/testing-tool-export`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ test_testing_tool_id: testTestingToolId }),
    },
  );

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      (data && (data.error || data.message)) ||
      "Failed to export testing tool report";
    throw new Error(message);
  }

  return data;
}